import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f51795a")

_pushScopeId("data-v-0f51795a")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "onetrip-page__filter__separator" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "dopTitle" }, "Билеты", -1)
const _hoisted_3 = { class: "dopTitle" }
const _hoisted_4 = { class: "all-params__wrapper noPadding" }
const _hoisted_5 = { class: "mainFormTransfer" }
const _hoisted_6 = {
  key: 0,
  class: "warningInfo"
}
const _hoisted_7 = {
  key: 1,
  class: "warningInfo"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_info_order = _resolveComponent("info-order")
  const _component_send_mail = _resolveComponent("send-mail")
  const _component_selector_person = _resolveComponent("selector-person")
  const _component_control_block = _resolveComponent("control-block")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_info_order, {
      order: _ctx.activeOffer,
      listOrders: _ctx.listOrders
    }, null, 8, ["order", "listOrders"]),
    _hoisted_1,
    _createVNode(_component_send_mail, { order: _ctx.activeOffer }, null, 8, ["order"]),
    _hoisted_2,
    _renderSlot(_ctx.$slots, "varians"),
    _createVNode("div", _hoisted_3, _toDisplayString(_ctx.titlePerson), 1),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.simpleBokingReq.PersonList, (person, index) => {
          return (_openBlock(), _createBlock(_component_selector_person, {
            key: person.uuid,
            contractId: _ctx.contractId,
            onSetPerson: $event => (_ctx.setPerson(index, $event)),
            onDeletePersone: $event => (_ctx.deletePersone(index)),
            dataShow: person,
            isShowMode: _ctx.isShowMode
          }, null, 8, ["contractId", "onSetPerson", "onDeletePersone", "dataShow", "isShowMode"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    (_ctx.showbtnAddPerson)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.addPerson(...args))),
          class: "order-create-btn"
        }, " + Добавить человека "))
      : _createCommentVNode("", true),
    (_ctx.userHasInfo && _ctx.selectTikets)
      ? (_openBlock(), _createBlock(_component_control_block, {
          key: 1,
          OfferId: _ctx.OfferId,
          PersonList: _ctx.simpleBokingReq.PersonList,
          listOrders: _ctx.listOrders,
          activeOffer: _ctx.activeOffer,
          selectTikets: _ctx.selectTikets,
          initData: _ctx.initData
        }, null, 8, ["OfferId", "PersonList", "listOrders", "activeOffer", "selectTikets", "initData"]))
      : _createCommentVNode("", true),
    (_ctx.showInfoMess)
      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          (!_ctx.selectTikets)
            ? (_openBlock(), _createBlock("div", _hoisted_6, " необходимо выбрать билет "))
            : _createCommentVNode("", true),
          (!_ctx.userHasInfo)
            ? (_openBlock(), _createBlock("div", _hoisted_7, " Заполните информацию о пассажирах "))
            : _createCommentVNode("", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("", true)
  ]))
})